import { render, staticRenderFns } from "./Restablecer.vue?vue&type=template&id=9c7ff01e&lang=pug"
import script from "./Restablecer.vue?vue&type=script&lang=js"
export * from "./Restablecer.vue?vue&type=script&lang=js"
import style0 from "./Restablecer.vue?vue&type=style&index=0&id=9c7ff01e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports